import { CommitmentSetupTabProps } from "features/commitments/setup/CommitmentSetupTabProps";
import FeeTable, { FeeTableGetFeeEditPathFn } from "features/fees/FeeTable";
import { useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentSetupTabFees: React.FC = () => {
  const { fundFamilyId, commitmentId } =
    useOutletContext<CommitmentSetupTabProps>();

  const feeEditPath = useCallback<FeeTableGetFeeEditPathFn>(
    (feeId) =>
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId: fundFamilyId! })
        .setup({})
        .commitments({})
        .feeOverride({ commitmentId: commitmentId!, feeId }).$,
    [commitmentId, fundFamilyId],
  );

  return (
    <PageTabBody>
      <FeeTable
        fundFamilyId={fundFamilyId!}
        retrieveParams={{ security_ownership_id: commitmentId }}
        getFeeEditPath={feeEditPath}
      />
    </PageTabBody>
  );
};
